import { render, staticRenderFns } from "./SalaryBatchesItem.vue?vue&type=template&id=7447446e&scoped=true"
import script from "./SalaryBatchesItem.vue?vue&type=script&lang=js"
export * from "./SalaryBatchesItem.vue?vue&type=script&lang=js"
import style0 from "./SalaryBatchesItem.vue?vue&type=style&index=0&id=7447446e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447446e",
  null
  
)

export default component.exports